/**
 * Vendor sidebar badge store.
 * Written by `<VendorBadgeSubscriber />`; read by `vendorsMenu`.
 */

import { create } from 'zustand';

interface VendorBadgesState {
  pendingVendors: number;
  draftProducts: number;
  pendingRatingResponses: number;
  setFromMetrics: (m: Partial<Pick<VendorBadgesState, 'pendingVendors' | 'draftProducts' | 'pendingRatingResponses'>>) => void;
  applyDelta: (m: Partial<Pick<VendorBadgesState, 'pendingVendors' | 'draftProducts' | 'pendingRatingResponses'>>) => void;
  reset: () => void;
}

const EMPTY = { pendingVendors: 0, draftProducts: 0, pendingRatingResponses: 0 };
const clamp = (n: number) => (n < 0 ? 0 : n);

export const useVendorBadgesStore = create<VendorBadgesState>((set) => ({
  ...EMPTY,
  setFromMetrics: (m) =>
    set({
      pendingVendors: clamp(m.pendingVendors ?? 0),
      draftProducts: clamp(m.draftProducts ?? 0),
      pendingRatingResponses: clamp(m.pendingRatingResponses ?? 0),
    }),
  applyDelta: (m) =>
    set((state) => ({
      pendingVendors: clamp(state.pendingVendors + (m.pendingVendors ?? 0)),
      draftProducts: clamp(state.draftProducts + (m.draftProducts ?? 0)),
      pendingRatingResponses: clamp(state.pendingRatingResponses + (m.pendingRatingResponses ?? 0)),
    })),
  reset: () => set(EMPTY),
}));
